































































































































































































































































































































































































































































































































































































































































































































































































































import { Watch } from "vue-property-decorator";
import { Mutation } from "vuex-class";
import VueI18n from "vue-i18n";
import { localize } from "vee-validate";
import {
    AppMutationTypes,
    SetCheckout,
    SetSettings,
    SetValidationRules
} from "../store";
import { PageType } from "../models";
import { getVisitTrackingRequest } from "../models/factories";
import { setCheckoutFromQueryParams } from "../helpers";

import Vue from "vue";
import Component from "vue-class-component";
import { Inject, Prop, Ref } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import {
    IAddress,
    IAddressValidationClient,
    AddressValidationClient,
    IError
} from "@elite/usps-client";
import { RestClient } from "@elite/restclient";
import { IModelState, IValidator } from "@elite/validation";
import { ErrorLog } from "@elite/vue-logging";
import {
    AppGetterTypes,
    AppActionTypes,
    SetPromotion,
    AddTracking
} from "../store";
import { BBBLogo, UpsellProductModals } from "../components";
import {
    //  Step1Route,
    ThankYouRoute
} from "../router";

import { getPaymentMethodCode } from "../helpers";

import { IPromotionModel, ISelectListItem, ICheckoutModel } from "../models";
import {
    getPromotionRequestModel,
    getTrackingRequest
} from "../models/factories";

@Component({ name: "CheckoutOneStep", components: { "bbb-logo": BBBLogo } })
export default class CheckoutOneStep extends Vue {
    /**
     * Vuetype doesn't recognize the reference to `$i18n` on `$root`.
     * All this is doing is defining that `$root` will be a Vue instance with the property `$i18n` (VueI18n)
     */
    $root!: Vue & { $i18n: VueI18n };

    @Getter(AppGetterTypes.promotion)
    promotion!: IPromotionModel;

    // this is mapped from :slug in the route
    @Prop({ required: true })
    promotionSlug!: string;

    @Action(AppActionTypes.getPromotion)
    getPromotion!: SetPromotion;

    @Action(AppActionTypes.addTracking)
    addTracking!: AddTracking;

    @Mutation(AppMutationTypes.setCheckout)
    setCheckout!: SetCheckout;

    @Getter(AppGetterTypes.checkout)
    checkout!: ICheckoutModel;
    isLoading = true;

    loading = true;

    errorMessage: string | null = null;

    get hasError(): boolean {
        return !!this.errorMessage;
    }
    @Inject()
    restClient!: RestClient;

    @Inject()
    modelState!: IModelState;

    @Inject()
    errorLog!: ErrorLog;

    @Getter(AppGetterTypes.uspsUserId)
    uspsUserId!: string;

    @Getter(AppGetterTypes.paymentMethods)
    paymentMethods!: ISelectListItem[];

    @Getter(AppGetterTypes.genericOrderFailedMessage)
    genericOrderFailedMessage!: string;

    @Action(AppActionTypes.getValidationRules)
    getValidationRules!: SetValidationRules;

    @Action(AppActionTypes.getSettings)
    getSettings!: SetSettings;

    // eslint-disable-next-line no-undef
    assetBaseUrl: string = process.env.VUE_APP_CDN_URL + "/assets";

    cvvModalOpen = false;
    orderIsSubmitting = false;

    maxExpirationDate = new Date();

    //Address Verification
    uspsAddressClient: IAddressValidationClient = new AddressValidationClient();
    addressInvalid = false;
    uspsAddress: IAddress | null = null;
    showAddressValidationPopup = false;
    initialSubmit = true;

    addressTypes = {
        shipping: "shipping",
        billing: "billing"
    };

    get invalidCheckbox(): boolean {
        return !!this.promotion.emailOptInRequired && !this.checkout.emailOptIn;
    }

    /** Take an action to notify the user according to our UX standards (see link above this code example). */
    handleError(): void {
        // Set the error message to display to the user
        this.errorMessage = this.genericOrderFailedMessage;
    }
    async mounted(): Promise<void> {
        // App mounted
        this.$root.$on("error", this.handleError);

        // get validations rules from the api and set in the Vuex store
        const rulesPromise = this.getValidationRules();

        // get application version from the api and set in the Vuex store
        const versionPromise = this.getSettings();

        await Promise.all([rulesPromise, versionPromise]);

        this.loading = false;

        const params = getPromotionRequestModel(
            this.$route.query,
            this.promotionSlug
        );

        await this.getPromotion(params);

        this.isLoading = false;

        this.setBackgroundAndTitle();

        // Set sessionId that will be used as Order GUID
        this.checkout.sessionId = this.promotion.sessionId;

        if (this.checkout.promotionCode === "") {
            this.checkout.promotionCode = this.promotion.promotionCode;
        }
        // Bosko
        // send tracking info
        if (this.promotion.sessionId) {
            this.addTracking(
                getTrackingRequest(
                    "checkout",
                    this.checkout,
                    this.promotion.sessionId
                )
            );
        }
    }

    @Watch("promotion")
    async onPromotionChange(): Promise<void> {
        if (!this.promotion) {
            return;
        }

        // Set locale
        if (this.promotion.locale) {
            this.setLocale(this.promotion.locale);
        }

        this.isLoading = false;

        // Bosko
        // track the page visit - this is separate from the email tracking event so we log visits on the initial page load, before we have a valid email address
        await this.addTracking(
            getVisitTrackingRequest(this.promotion, PageType.EmailPage)
        );
    }

    @Watch("checkout")
    setCheckoutQueryParams(): void {
        if (!this.checkout) {
            return;
        }

        setCheckoutFromQueryParams(this.checkout, this.$route.query);
    }

    /**
     * Sets the locale of the site based on the current promotion.
     */
    setLocale(locale: string): void {
        if (!locale) {
            return;
        }

        // vue-i18n:
        this.$root.$i18n.locale = locale;
        // vee-validate:
        localize(locale);
    }

    hasUpsells(): boolean {
        return (
            !!this.promotion.upsellProducts &&
            this.promotion.upsellProducts.length > 0
        );
    }

    @Ref("upsells")
    upsellModals!: UpsellProductModals;

    @Ref("validationObserver")
    validationObserver!: IValidator;

    get localizedPaymentMethods(): ISelectListItem[] {
        const paymentMethods = this.paymentMethods;

        // Get localized names
        // ex:  common.credit-card
        //      common.debit-card
        const localize = (name: string): string =>
            this.$t(
                "common." + name.toLowerCase().replace(" ", "-")
            ).toString();

        paymentMethods.forEach(
            i => (i.text = i.text ? localize(i.text) : i.text)
        );

        return paymentMethods;
    }

    get uspsAddressIsDifferent(): boolean {
        if (!this.uspsAddress || !this.checkout) {
            return false;
        }

        return (
            this.uspsAddress.address2 !==
                this.checkout.shippingAddress?.address ||
            this.uspsAddress.address1 !==
                this.checkout.shippingAddress?.address2 ||
            this.uspsAddress.city !== this.checkout.shippingAddress?.city ||
            this.uspsAddress.state !== this.checkout.shippingAddress?.state ||
            this.uspsAddress.zip5 !== this.checkout.shippingAddress?.zipCode
        );
    }

    get validExpirationDate(): boolean {
        return (
            !this.checkout.expirationDate ||
            new Date(this.checkout.expirationDate) > this.maxExpirationDate
        );
    }

    async validate(): Promise<boolean> {
        return (
            this.validExpirationDate &&
            (await this.validationObserver.validate())
        );
    }

    async processOrderClick(): Promise<void> {
        // If the order is already submitting, do not attempt to place another.
        if (this.orderIsSubmitting) {
            return;
        }

        if (!(await this.validate())) {
            this.orderIsSubmitting = false;
            return;
        }

        // Show upsells before order submission
        if (this.hasUpsells() && this.initialSubmit) {
            this.initialSubmit = false;

            await this.upsellModals.showUpsells();
            this.upsellModals.$once("finished", async () => {
                await this.processOrder();
                this.orderIsSubmitting = false;
            });
        } else {
            this.initialSubmit = false;
            await this.processOrder();

            this.orderIsSubmitting = false;
        }
    }

    async processOrder(): Promise<void> {
        const orderId = await this.submitOrder();

        if (!orderId) {
            return;
        }

        // Proceed with redirecting the user to the thank-you page.
        this.$router.push({
            name: ThankYouRoute.name,
            params: {
                slug: this.promotionSlug,
                orderId: orderId
            },
            query: this.$route.query // Pass all current query parameters to ThankYou page
        });
    }

    async submitOrder(): Promise<string | null> {
        await this.cleanseShippingAddress();
        this.orderIsSubmitting = true;

        if (this.addressInvalid) {
            return null;
        }

        this.checkout.expirationDateYear = Number(
            this.checkout.expirationDateYear
        );

        const paymentMethodCode = getPaymentMethodCode(
            this.checkout.cardNumber || ""
        );

        if (paymentMethodCode) {
            this.checkout.paymentMethodCode = paymentMethodCode;
        } else {
            this.modelState.addErrors(
                {
                    cardNumber: [
                        this.$t("step2.invalid-credit-card").toString()
                    ]
                },
                this
            );
            return null;
        }

        this.modelState.clear(this);

        try {
            // Place order
            const response = await this.restClient.postJson<string>(
                "/api/Checkout",
                this.checkout
            );

            if (!response) {
                return null;
            }

            if (this.modelState.hasErrors(response)) {
                this.modelState.addResponseErrors(response, this);
                // expiration date is special because it has month and year fields, but validated as a single DateTime
                // copy it from property errors to model errors so it shows in the validation summary
                if (this.modelState.propertyErrors.expirationDate) {
                    this.modelState.modelErrors.push(
                        this.modelState.propertyErrors.expirationDate[0]
                    );
                }

                return null;
            }

            return response.data || null;
        } catch (error) {
            this.modelState.modelErrors.push(this.genericOrderFailedMessage);

            this.errorLog.send(error as Error, this);

            return null;
        }
    }

    async cleanseShippingAddress(): Promise<void> {
        if (!this.checkout) {
            throw new Error();
        }

        const address: IAddress = {
            // These are swapped between line 2 and 1 --on purpose--.
            // USPS seems to return what we think of "line 1" as address2
            address2: this.checkout.shippingAddress?.address || undefined,
            address1: this.checkout.shippingAddress?.address2 || undefined,
            city: this.checkout.shippingAddress?.city || undefined,
            state: this.checkout.shippingAddress?.state || undefined,
            zip5: this.checkout.shippingAddress?.zipCode || undefined
        };

        try {
            const validAddress = await this.uspsAddressClient.validate(
                this.uspsUserId,
                address
            );

            this.addressInvalid = false;
            this.uspsAddress = validAddress;
            this.showAddressValidationPopup = this.uspsAddressIsDifferent;
        } catch (e) {
            this.uspsAddress = null;

            // If the request failed (e.g. the API SSL cert expired), don't treat it as invalid
            const uspsError = e as IError;
            const error = e as Error;

            if (
                (uspsError && uspsError.description === "Failed") ||
                (error && error.message === "Network Error")
            ) {
                this.addressInvalid = false;
                this.showAddressValidationPopup = false;
            } else {
                this.addressInvalid = true;
                this.showAddressValidationPopup = true;
            }
        }

        if (!this.addressInvalid && this.showAddressValidationPopup) {
            await new Promise<void>(resolve => {
                this.$on("use-usps-address", () => {
                    this.$off("ignore-usps-address");

                    if (!this.uspsAddress) {
                        return;
                    }

                    // Same as before: address1/address2 are flip-flopped on the USPS return data
                    this.checkout.shippingAddress =
                        this.checkout.shippingAddress || {};
                    this.checkout.shippingAddress.address =
                        this.uspsAddress.address2 || "";
                    this.checkout.shippingAddress.address2 =
                        this.uspsAddress.address1 || "";
                    this.checkout.shippingAddress.city =
                        this.uspsAddress.city || "";
                    this.checkout.shippingAddress.state =
                        this.uspsAddress.state || "";
                    this.checkout.shippingAddress.zipCode =
                        this.uspsAddress.zip5 || "";

                    resolve();
                });

                this.$on("ignore-usps-address", () => {
                    this.$off("use-usps-address");
                    resolve();
                });
            });
        }

        this.uspsAddress = null;
    }

    phoneBlur(key: string): void {
        if (!this.checkout) {
            return;
        }

        let phone;

        if (key === this.addressTypes.shipping) {
            phone = this.checkout.shippingAddress?.phone;
        }

        if (key === this.addressTypes.billing) {
            phone = this.checkout.billingAddress?.phone;
        }

        if (!phone) {
            return;
        }

        let replaced = phone.replace(/[^\d]/g, "");
        replaced = replaced.padEnd(10, "0");

        phone = `${replaced.substr(0, 3)}-${replaced.substr(
            3,
            3
        )}-${replaced.substr(6, 4)}`;

        if (key === this.addressTypes.shipping) {
            this.checkout.shippingAddress = this.checkout.shippingAddress || {};
            this.checkout.shippingAddress.phone = phone;
        }

        if (key === this.addressTypes.billing) {
            this.checkout.billingAddress = this.checkout.billingAddress || {};
            this.checkout.billingAddress.phone = phone;
        }
    }

    async processUpsells(upsellIds: number[]): Promise<void> {
        this.checkout.upsellIds = upsellIds;
    }

    setBackgroundAndTitle(): void {
        //Set background color
        if (this.promotion.backgroundColor) {
            document.body.style.backgroundColor = this.promotion.backgroundColor;
        }

        //Set Page Title
        if (this.promotion.name) {
            document.title = this.promotion.name;
        }
    }

    // redirectToStep1(): Promise<Route> {
    //     return this.$router.push({
    //         name: Step1Route.name,
    //         params: { slug: this.promotionSlug },
    //         query: this.$route.query // Pass all current query parameters back to step 1
    //     });
    // }
}
